import React from 'react';

import mixin from 'react-mixin';
import { forwardPropsToState } from '../../../utils/react_utils';
import LecomLabel from '../label/label';
import { DD_MM_YYYY_BAR, MM_DD_YYYY_BAR, formatDateToBasic } from 'utils/date_utils_new.js';

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)
@forwardPropsToState([{ prop: 'value' }])

export default class InputDatepickerMobile extends React.Component {
	constructor(props) {
		super(props);

		this.isActive = true;
	}

	returnValue() {
		const { value } = this.state;
		const currentLocale = Realize.i18n.currentLocale.toLowerCase();	

		if (DD_MM_YYYY_BAR.test(value) || MM_DD_YYYY_BAR.test(value)) {			
			const valueSplitted = value.split("/");

			if (currentLocale === 'pt-br' || currentLocale === 'es') {
				return `${valueSplitted[2]}-${valueSplitted[1]}-${valueSplitted[0]}`;
			}
			else {
				return `${valueSplitted[2]}-${valueSplitted[0]}-${valueSplitted[1]}`;
			}
		}					
		
		return formatDateToBasic(value, "YYYY-MM-DD");	
	}

	datapickerReadOnly(){
		const readOnly = this.props.readOnly;
		const disabled = this.props.disabled

		if(readOnly === true || disabled === true){
			return ''
		} else {
			return '▼'
		}
	}

	render() {
		return (
			<div className="container-datepicker-mobile">
				<span className="caret">{this.datapickerReadOnly()}</span>
				<input
					{...this.props}
					placeholder={this.getPlaceholder()}
					className={`${this.inputClassName()} datepicker-mobile`}
					onChange={this._handleChange.bind(this)}
					onFocus={this._handleFocus.bind(this)}
					value={this.returnValue()}
					type="date"
					autocorrect="off"
					ref="input"
				/>
				<LecomLabel
					{...this.propsWithoutCSS()}
					active={this.isActive}
				/>
			</div>
		);
	}
}
